export class VariableDocument {
    uuid: string;
    value: string
}